import {
  AvcoreSubcribeStreamApiCredentials,
  RoomContextId,
  StreamId,
  StreamKind
} from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const streamAdd = createAction(
  "[Remote Conference Stream] Stream Add",
  props<{
    id: StreamId;
    kinds: StreamKind[];
    credentials: AvcoreSubcribeStreamApiCredentials;
    roomContextId: RoomContextId;
  }>()
);

export const streamDelete = createAction(
  "[Remote Conference Stream] Stream Delete",
  props<{ id: StreamId }>()
);

export const dispose = createAction("[Remote Conference Stream] Dispose");

// A subscribe that failed for good (permanent error or retries exhausted):
// the stream stays without media until it is added again.
export const streamSubscribeFailure = createAction(
  "[Remote Conference Stream] Stream Subscribe Failure",
  props<{ id: StreamId }>()
);

// Converge to the authoritative stream list, requested at `requestedAt`
// (performance.now()), see RemoteConferenceStreamManager.reconcile().
export const reconcile = createAction(
  "[Remote Conference Stream] Reconcile",
  props<{
    streams: {
      id: StreamId;
      kinds: StreamKind[];
      credentials: AvcoreSubcribeStreamApiCredentials;
      roomContextId: RoomContextId;
    }[];
    requestedAt: number;
  }>()
);
